import { render, staticRenderFns } from "./stockProductionSettingsEditor.vue?vue&type=template&id=161c99e9&"
import script from "./stockProductionSettingsEditor.vue?vue&type=script&lang=js&"
export * from "./stockProductionSettingsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports